import CommonAvatar from "@/modules/common/components/ui-kit/common-avatar";
import useSanitizeMentions from "@/modules/lead-page/new/hooks/sanitize-mentions.hook";
import { Box, Typography, useTheme } from "@mui/material";

interface MentionSuggestionProps {
  suggestion: any;
  focused: boolean;
  mentionedUsers: {
    id: any;
    display: any;
    color: any;
    name: any;
  }[];
}

const MentionSuggestion = ({
  suggestion,
  focused,
  mentionedUsers,
}: MentionSuggestionProps) => {
  const theme = useTheme();

  const sanitizedMentionData = useSanitizeMentions({ mentionedUsers });

  const user = sanitizedMentionData.find((u) => u.id === suggestion.id);

  return (
    <Box
      key={suggestion.id}
      display="flex"
      alignItems="center"
      gap={1}
      sx={{
        backgroundColor: focused ? "#f5f5f5" : "#fff",
        padding: `${theme.nawy.spacing.xs} ${theme.nawy.spacing.sm}`,
        borderBottom: "1px solid #eee",
        cursor: "pointer",
        width: "100%",
      }}
    >
      <CommonAvatar name={suggestion.display} color={user?.color || "#ccc"} />
      <Typography
        sx={{ ...theme.nawy.typography.english.variants.body.sm.semibold }}
      >
        {suggestion.display}
      </Typography>
    </Box>
  );
};

export default MentionSuggestion;
